<template>
<div>
  <el-tab v-model="tabIndex">
    <el-tab-item title="Distribution">
      <br>

      <kpi-value
        :value="nrOfRides"
        label="Rides last 14 days"
        />

      <br><br>

      <bar-graph
        :height="200"
        :data="totAvgAngleD"
        :options="{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }"
        />

        <br><br>

      <bar-graph
        :height="200"
        :data="totAlarmCount"
        :options="{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }"
        />

        <br><br>

      <bar-graph
        :height="200"
        :data="nrOfRecords"
        :options="{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }"
        />
    </el-tab-item>
    <el-tab-item title="Rides">
      <div
        v-for="ride in rides"
        :key="ride.id"
        >
        <el-inline margin-top nowrap margin-bottom>
          <kpi-value
            :value="ride.serialNumber"
            label="Serial number"
            />

          <kpi-value
            :value="ride.data.length"
            label="Data points"
            />

          <kpi-value
            :value="ride.header.tot_alarm_count"
            label="Total alarm count"
            />

          <kpi-value
            :value="ride.header.tot_avg_angle_d"
            label="Average angle"
            />
        </el-inline>
        <el-inline margin-top space-between>
          <i>{{new Date(ride.timestamp).toLocaleString()}}</i>
          <i style="color: #eee;">{{ride.id}}</i>
        </el-inline>

        <el-collapse-header title="Ride data">
          <line-diagram
            :height="100"
            :data="getRideLine(ride.data, 'avg_angle_d')"
            :options="{
              scales: {
                xAxes: [{
                  type: 'time',
                  time: {
                    unit: 'day'
                  }
                }]
              }
            }"
            />
          <line-diagram
            :height="100"
            :data="getRideLine(ride.data, 'alarm_count')"
            :options="{
              scales: {
                xAxes: [{
                  type: 'time',
                  time: {
                    unit: 'day'
                  }
                }]
              }
            }"
            />
        </el-collapse-header>

        <el-delimiter />
      </div>
    </el-tab-item>
  </el-tab>
</div>
</template>
<script>
import dataLog from 'services/dataLog.js'
import BarGraph from './BarGraph.vue'
import KpiValue from './KpiValue.vue'
import LineDiagram from './LineDiagram.vue'

function getHistogramSteps (values, steps) {
  // values = [1, 2, 3, 2, 5, ...]
  // const minValue = Math.min(...values)
  const maxValue = Math.max(...values)
  const labels = []
  let data = []
  let total = 0

  for (let i = 1; i <= steps + 1; i++) {
    let label = `${Math.round((i / steps * maxValue) * 10) / 10}`

    if (i === 1) {
      label = '<' + label
    } else if (i === steps + 1) {
      label = '>' + label
    }

    labels.push(label)
    data.push(0)
  }

  values.forEach(value => {
    let index = Math.round(value / maxValue * steps)
    data[index]++
    total++
  })

  data = data.map(x => x / total * 100)

  return { labels, data }
}

export default {
  components: { BarGraph, KpiValue, LineDiagram },
  mounted () {
    dataLog.getRides()
  },
  computed: {
    rides () {
      return this.$store.getters.rides
        .filter(ride => ride.data.length > 1)
        .sort((a, b) => b.timestamp - a.timestamp)
    },
    nrOfRides () {
      return this.rides.length
    },
    totAvgAngleD () {
      return this.getHistogramData('tot_avg_angle_d')
    },
    totAlarmCount () {
      return this.getHistogramData('tot_alarm_count / nr_of_records', ride => {
        return ride.header.tot_alarm_count / ride.header.nr_of_records
      })
    },
    nrOfRecords () {
      return this.getHistogramData('nr_of_records')
    }
  },
  data () {
    return {
      tabIndex: 0,
      histogramSteps: 5
    }
  },
  methods: {
    getHistogramData (dataAttr, callback) {
      const data = {
        labels: [],
        datasets: [{
          label: dataAttr,
          backgroundColor: '#f87979',
          data: []
        }]
      }

      const alarmAngles = this.rides.map(d => {
        if (callback) {
          return callback(d)
        } else {
          return d.header[dataAttr]
        }
      })
      const histogramData = getHistogramSteps(alarmAngles, this.histogramSteps)

      data.datasets[0].data = histogramData.data
      data.labels = histogramData.labels

      return data
    },
    getRideLine (rideData, type) {
      // { alarm_count, avg_angle_d }

      const color = type === 'alarm_count' ? '#f87979' : '#4889C6'

      const data = {
        datasets: [{
          label: type,
          backgroundColor: color,
          steppedLine: true,
          data: rideData.map((dataPoint, index) => ({
            x: index,
            y: dataPoint[type]
          }))
        }]
      }

      return data
    }
  }
}
</script>
